module.exports = __webpack_public_path__ + "img/KC_YW.cbb498c6.png";